export const downloadSvg = (svg: SVGSVGElement, filename: string) => {
  const svgData = new XMLSerializer().serializeToString(svg);

  const blob = new Blob([svgData], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();

  URL.revokeObjectURL(url);
};
